var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!!_vm.item.config)?_c('InfoBranch',{style:({
      marginTop: '2px',
    }),attrs:{"content":_vm.delayString}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }